<template>
  <footer class="apple-footer">
    <div class="apple-footer__inner">
      <div class="apple-footer__nav">
        <a href="#" class="apple-footer__link" @click.prevent="toPage('home')">企业简介</a>
        <a href="#" class="apple-footer__link" @click.prevent="toPage('analyse')">市场分析</a>
        <a href="#" class="apple-footer__link" @click.prevent="toPage('product')">产品介绍</a>
        <a href="#" class="apple-footer__link" @click.prevent="toPage('technology')">核心技术</a>
        <a href="#" class="apple-footer__link" @click.prevent="toPage('demand')">市场需求</a>
      </div>
      <div class="apple-footer__divider"></div>
      <div class="apple-footer__bottom">
        <div class="apple-footer__info">
          <p class="apple-footer__company">北京中科悦信科技有限公司</p>
          <p class="apple-footer__address">
            公司地址：北京市房山区天星街1号院10号楼12层1201-C0206<br />
            服务热线：400-860-7086<br />
            官方网址：http://www.bjzkyxkj.com<br />
            邮箱地址：zhongkeyuexin@163.com
          </p>
        </div>
        <div class="apple-footer__qrcode">
          <img class="apple-footer__qrcode-img" referrerpolicy="no-referrer" :src="qrcodeSrc" alt="微信公众号" />
          <span class="apple-footer__qrcode-text">扫一扫关注微信公众号</span>
        </div>
      </div>
      <div class="apple-footer__legal">
        <span>京ICP备2024085931号</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footerPage",
  data() {
    return { qrcodeSrc: require('@/assets/qrcode_for_gh_68abbe3e0def_1280.jpg') }
  },
  methods: {
    toPage(url) {
      if (this.$route.name === url) return;
      this.$router.push({ name: url });
    },
  },
};
</script>

<style scoped>
.apple-footer {
  background: var(--apple-footer-bg);
  color: var(--apple-footer-text);
  padding: 40px 22px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.apple-footer__inner {
  max-width: 980px;
  margin: 0 auto;
}

.apple-footer__nav {
  display: flex;
  flex-wrap: wrap;
  gap: 24px 40px;
  margin-bottom: 24px;
}

.apple-footer__link {
  font-size: 12px;
  color: var(--apple-footer-text);
  text-decoration: none;
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: var(--radius-sm);
  display: inline-block;
  transition: color var(--transition-fast), transform var(--transition-fast),
    background var(--transition-fast);
}

.apple-footer__link:hover {
  color: var(--apple-black);
  background: rgba(0, 0, 0, 0.04);
}

.apple-footer__link:active {
  transform: scale(0.96);
  background: rgba(0, 0, 0, 0.06);
}

.apple-footer__divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.apple-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 48px;
  flex-wrap: wrap;
}

.apple-footer__info {
  flex: 1;
  min-width: 200px;
}

.apple-footer__company {
  font-size: 14px;
  font-weight: 500;
  color: var(--apple-black);
  margin: 0 0 12px;
}

.apple-footer__address {
  font-size: 12px;
  line-height: 1.8;
  margin: 0;
  color: var(--apple-dark-gray);
}

.apple-footer__qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.apple-footer__qrcode-img {
  width: 80px;
  height: 80px;
  border-radius: var(--radius-md);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.apple-footer__qrcode-text {
  font-size: 11px;
  color: var(--apple-dark-gray);
}

.apple-footer__legal {
  margin-top: 24px;
  padding-top: 16px;
  font-size: 11px;
  color: var(--apple-gray);
}
</style>
